import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {

    environment: string = window.location.origin;

    constructor() { }

    getEnvironment(): string {
        if (this.environment.includes('denv')) {
            this.environment.replace('denv', 'tenv');
        }
        return this.environment;
    }

}